module.exports = __webpack_public_path__ + "static/media/GothamMedium.364995ec.woff";